import { get } from "lodash";
import styled from "styled-components";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers";

import { TextField } from "./index";
import { colors } from "../pages/css components/Style";

const DateTimePicker = styled(MuiDateTimePicker)`
  .MuiTextField-root {
    padding: 8px;
    border-color: #909090 !important;
  }

  & label.Mui-focused {
    color: ${colors.publicisBlue};
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${colors.publicisBlue};
    }
  }

  .MuiInputLabel-root {
    color: #333;
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
  }

  .MuiOutlinedInput-root {
    font-size: 16px;
    border-color: ${colors.publicisBlue};
    border-radius: 5px;
  }

  .Mui-disabled {
    color: rgba(0, 0, 0, 0.66);
    font-size: 16px;
    border-radius: 5px;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
  }

  .MuiInputLabel-outlined {
    font-size: 16px;
  }

  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: #f5f5f5 !important;
    border: 1px solid #c4cacb !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.$isFilled
        ? colors.publicisBlue + " !important"
        : colors.grey + " !important"};
  }

  #mui-7-helper-text {
    color: red;
  }
  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }
`;
export default function MUIDateTimePicker({
  formikProps,
  alternate,
  ...props
}) {
  const isFilled = !!get(formikProps.values, props.name, "");

  return (
    <DateTimePicker
      {...props}
      required
      $isFilled={isFilled}
      name={props.name}
      formikProps={formikProps}
      label={props.label}
      minDateTime={props.minDateTime}
      value={
        get(formikProps.values, props.name, "")
          ? new Date(get(formikProps.values, props.name, ""))
          : get(formikProps.values, props.name, "")
      }
      ampm
      closeOnSelect={false}
      inputProps={{ readOnly: true }}
      onChange={(newValue) => {
        let n = String(props.name).split(".")[0];
        formikProps.setValues((prevVal) => ({
          ...prevVal,
          [n]: { value: newValue },
          [alternate]: newValue,
        }));
      }}
      sx={{ width: "100%" }}
      slotProps={{
        textField: {
          size: "small",
          required: true,
          error:
            !!get(formikProps.touched, props.name) &&
            !!get(formikProps.errors, props.name),

          helperText:
            !!get(formikProps.touched, props.name) &&
            get(formikProps.errors, props.name),

          sx: {
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: isFilled ? colors.publicisBlue : colors.grey,
              },
              "&:hover fieldset": {
                borderColor: isFilled ? colors.publicisBlue : colors.grey,
              },
              "&.Mui-focused fieldset": {
                borderColor: colors.publicisBlue,
                borderWidth: 2,
              },

              "&.Mui-error": {
                borderColor: isFilled
                  ? `${colors.publicisBlue}!important`
                  : `${colors.grey}!important`,
              },
            },
          },
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          required
          autoComplete="off"
          label={props.label}
          name={props.name}
          formikProps={formikProps}
        />
      )}
    />
  );
}
